import { z } from 'zod';

export const createNameSchema = (nameType = 'Name', length = 25) =>
  z
    .string()
    .trim()
    .min(1, `${nameType} is required`)
    .max(length, `${nameType} must be ${length} characters or less`)
    .refine(s => !/[?#%;]/u.test(s), `${nameType} has invalid characters`)
    .refine(s => s !== '.' && s !== '..', `${nameType} is not valid`)
    // eslint-disable-next-line no-control-regex
    .refine(s => !/[\u0000-\u001F\u007F]/.test(s), `${nameType} has invalid characters`)
    .transform(s => s.normalize('NFC'));
